import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import classNames from "classnames";
import { Dropdown, ButtonDisclosure } from "@toddle-edu/ds-web";
import classes from "./DurationDropdown.scss";
import { DurationDropdownOverlay } from "./DurationDropdownOverlay";

const DurationDropdown = props => {
  const {
    hours = 1,
    minutes = 0,
    durationMenus,
    disabled,
    isDeliverySettings,
    t,
    testId,
  } = props;

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const durationMenuList = useRef({});

  useEffect(() => {
    if (!isDropdownVisible) {
      return;
    }

    if (!_.isEmpty(durationMenuList.current)) {
      if (durationMenuList.current[`minutes-${minutes}`]) {
        durationMenuList.current[`minutes-${minutes}`].scrollIntoView({
          block: "center",
        });
      }

      if (durationMenuList.current[`hours-${hours}`]) {
        durationMenuList.current[`hours-${hours}`].scrollIntoView({
          block: "center",
        });
      }
    }
  }, [isDropdownVisible]);

  return (
    <Dropdown
      overlay={
        <DurationDropdownOverlay
          durationMenus={durationMenus}
          durationMenuList={durationMenuList}
          setIsDropdownVisible={setIsDropdownVisible}
        />
      }
      visible={isDropdownVisible}
      onVisibleChange={setIsDropdownVisible}
      disabled={disabled}
      destroyPopupOnHide={false}
      testId={`${testId}-shareSettingsStep-timedTestDuration`}
    >
      <ButtonDisclosure
        dsVersion="2.0"
        variant="neutral"
        type="outlined"
        size={isDeliverySettings ? "large" : "medium"}
        _leagcy_variant={"outlined-subtle"}
        _leagcy_size={isDeliverySettings ? "large" : "small"}
        testId={`${testId}-shareSettingsStep-timedTestDuration`}
      >
        <div
          className={classNames({
            [classes.dropdownButtonContainer]: isDeliverySettings,
          })}
        >
          {t("common:hr_min", { hours, minutes })}
        </div>
      </ButtonDisclosure>
    </Dropdown>
  );
};

export default DurationDropdown;
